import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';
import formatPrice from '../../utils/price/format-price';

type GetCartViewResponse = { data: { items: { cart: Cart } } };

const getCartView = (): Promise<Cart> =>
    (axios.get(`${API_URLS.CART}view`) as unknown as Promise<GetCartViewResponse>).then((response) => {
        const { cart } = response.data.items;

        cart.loaded = true;
        cart.originalPrice = formatPrice(cart.originalPrice);
        cart.finalPrice = formatPrice(cart.finalPrice);
        cart.totalVoucherDiscount = cart.totalVoucherDiscount ? formatPrice(cart.totalVoucherDiscount) : 0;
        cart.cartItems = cart.cartItems.map((item) => ({ ...item, finalPrice: formatPrice(item.finalPrice) }));

        return cart;
    });

export default getCartView;
